var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilter2 = function SvgFilter2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M16.857 3H3.143a1.16 1.16 0 0 0-.808.325A1.1 1.1 0 0 0 2 4.111c0 .295.12.577.335.786.214.208.505.325.808.325h13.714c.303 0 .594-.117.808-.325S18 4.406 18 4.11s-.12-.577-.335-.786A1.16 1.16 0 0 0 16.857 3m-1.714 5.556H4.857a1.16 1.16 0 0 0-.808.325 1.1 1.1 0 0 0-.335.786c0 .294.12.577.335.785.214.209.505.326.808.326h10.286c.303 0 .594-.117.808-.326.214-.208.335-.49.335-.785s-.12-.578-.335-.786a1.16 1.16 0 0 0-.808-.325m-4 5.555H8.857a1.16 1.16 0 0 0-.808.325 1.1 1.1 0 0 0-.335.786c0 .295.12.578.335.786.214.208.505.325.808.325h2.286c.303 0 .594-.117.808-.325s.335-.491.335-.786c0-.294-.12-.577-.335-.785a1.16 1.16 0 0 0-.808-.326"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilter2);
export default ForwardRef;